<template>
  <div>
    <div class="section-hero-subpage bg-color-octrary">
      <video autoplay loop muted playsinline width="640" preload="metadata" poster="/frontend/assets/images/og-image.jpg">
        <source src="/frontend/assets/videos/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="container">
        <div class="paragraph--normal text-uppercase text-color-quinary mb-2">
          <span class="notranslate" translate="no">SELECTED</span> CARS
        </div>
        <h1 class="heading--0 text-uppercase text-color-quinary border-bottom-quinary padding-bottom-2 margin-bottom-3-lg">
          Worldwide <span class="fw-light">Car</span><br />
          Export
        </h1>
        <div class="row">
          <div class="col-lg-7">
            <p class="paragraph--xlarge text-color-senary">
              We export premium European vehicles to 60+ countries worldwide.
              Competitive pricing, full documentation, door-to-door delivery.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Regions -->
    <div v-for="(region, ri) in regions" :key="region.name" class="section-small" :class="ri % 2 === 0 ? 'bg-color-tertiary' : 'bg-color-primary'">
      <div class="container">
        <h2 class="heading--4 fw-light text-color-quinary text-uppercase border-bottom-quinary padding-bottom-3-lg padding-bottom-2 margin-bottom-5-lg margin-bottom-3">
          {{ region.name }}
        </h2>
        <div class="row">
          <div v-for="dest in region.destinations" :key="dest.slug" class="col-lg-4 col-md-6 mb-4">
            <router-link :to="`/export/${dest.slug}`" class="dest-card">
              <div class="dest-card--flag">{{ dest.flag }}</div>
              <div class="dest-card--info">
                <div class="dest-card--name">{{ dest.name }}</div>
                <div class="dest-card--desc">{{ dest.shortDesc }}</div>
              </div>
              <div class="dest-card--arrow">&rarr;</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- General CTA -->
    <div class="section-small bg-color-primary text-center">
      <div class="container">
        <h2 class="heading--3 text-color-quinary text-uppercase mb-4">
          Your Country Not Listed?
        </h2>
        <p class="paragraph--xlarge text-color-senary mb-5">
          We export to any country worldwide. Contact us for a custom quote.
        </p>
        <div class="d-flex justify-content-center gap-3 flex-wrap">
          <a href="https://wa.me/421949006016" target="_blank" class="btn btn--normal btn--primary text-uppercase">
            WhatsApp Us
          </a>
          <router-link to="/contacts" class="btn btn--normal btn--primary text-uppercase">
            Contact Form
          </router-link>
        </div>
      </div>
    </div>

    <AppMarquee />
  </div>
</template>

<script>
import AppMarquee from '../components/AppMarquee.vue';

export default {
  components: { AppMarquee },
  data() {
    return {
      regions: [
        {
          name: 'Europe',
          destinations: [
            { slug: 'albania', name: 'Albania', flag: '\uD83C\uDDE6\uD83C\uDDF1', shortDesc: 'Tirana, Durr\u00ebs, Vlor\u00eb' },
            { slug: 'andorra', name: 'Andorra', flag: '\uD83C\uDDE6\uD83C\uDDE9', shortDesc: 'Andorra la Vella, Escaldes-Engordany' },
            { slug: 'austria', name: 'Austria', flag: '\uD83C\uDDE6\uD83C\uDDF9', shortDesc: 'Vienna, Salzburg, Graz, Innsbruck' },
            { slug: 'belgium', name: 'Belgium', flag: '\uD83C\uDDE7\uD83C\uDDEA', shortDesc: 'Brussels, Antwerp, Ghent, Bruges' },
            { slug: 'bosnia-and-herzegovina', name: 'Bosnia and Herzegovina', flag: '\uD83C\uDDE7\uD83C\uDDE6', shortDesc: 'Sarajevo, Banja Luka, Mostar' },
            { slug: 'bulgaria', name: 'Bulgaria', flag: '\uD83C\uDDE7\uD83C\uDDEC', shortDesc: 'Sofia, Plovdiv, Varna, Burgas' },
            { slug: 'croatia', name: 'Croatia', flag: '\uD83C\uDDED\uD83C\uDDF7', shortDesc: 'Zagreb, Split, Dubrovnik, Rijeka' },
            { slug: 'cyprus', name: 'Cyprus', flag: '\uD83C\uDDE8\uD83C\uDDFE', shortDesc: 'Nicosia, Limassol, Larnaca, Paphos' },
            { slug: 'czech-republic', name: 'Czech Republic', flag: '\uD83C\uDDE8\uD83C\uDDFF', shortDesc: 'Prague, Brno, Ostrava, Plze\u0148' },
            { slug: 'denmark', name: 'Denmark', flag: '\uD83C\uDDE9\uD83C\uDDF0', shortDesc: 'Copenhagen, Aarhus, Odense, Aalborg' },
            { slug: 'estonia', name: 'Estonia', flag: '\uD83C\uDDEA\uD83C\uDDEA', shortDesc: 'Tallinn, Tartu, Narva' },
            { slug: 'finland', name: 'Finland', flag: '\uD83C\uDDEB\uD83C\uDDEE', shortDesc: 'Helsinki, Espoo, Tampere, Turku' },
            { slug: 'france', name: 'France', flag: '\uD83C\uDDEB\uD83C\uDDF7', shortDesc: 'Paris, Lyon, Marseille, Nice, Toulouse' },
            { slug: 'germany', name: 'Germany', flag: '\uD83C\uDDE9\uD83C\uDDEA', shortDesc: 'Berlin, Munich, Hamburg, Frankfurt, Stuttgart' },
            { slug: 'greece', name: 'Greece', flag: '\uD83C\uDDEC\uD83C\uDDF7', shortDesc: 'Athens, Thessaloniki, Heraklion, Patras' },
            { slug: 'hungary', name: 'Hungary', flag: '\uD83C\uDDED\uD83C\uDDFA', shortDesc: 'Budapest, Debrecen, Szeged, Miskolc' },
            { slug: 'iceland', name: 'Iceland', flag: '\uD83C\uDDEE\uD83C\uDDF8', shortDesc: 'Reykjavik, K\u00f3pavogur, Akureyri' },
            { slug: 'ireland', name: 'Ireland', flag: '\uD83C\uDDEE\uD83C\uDDEA', shortDesc: 'Dublin, Cork, Galway, Limerick' },
            { slug: 'italy', name: 'Italy', flag: '\uD83C\uDDEE\uD83C\uDDF9', shortDesc: 'Rome, Milan, Naples, Turin, Florence' },
            { slug: 'kosovo', name: 'Kosovo', flag: '\uD83C\uDDFD\uD83C\uDDF0', shortDesc: 'Pristina, Prizren, Peja' },
            { slug: 'latvia', name: 'Latvia', flag: '\uD83C\uDDF1\uD83C\uDDFB', shortDesc: 'Riga, Daugavpils, Liep\u0101ja' },
            { slug: 'liechtenstein', name: 'Liechtenstein', flag: '\uD83C\uDDF1\uD83C\uDDEE', shortDesc: 'Vaduz, Schaan' },
            { slug: 'lithuania', name: 'Lithuania', flag: '\uD83C\uDDF1\uD83C\uDDF9', shortDesc: 'Vilnius, Kaunas, Klaip\u0117da' },
            { slug: 'luxembourg', name: 'Luxembourg', flag: '\uD83C\uDDF1\uD83C\uDDFA', shortDesc: 'Luxembourg City, Esch-sur-Alzette' },
            { slug: 'malta', name: 'Malta', flag: '\uD83C\uDDF2\uD83C\uDDF9', shortDesc: 'Valletta, Birkirkara, Sliema' },
            { slug: 'moldova', name: 'Moldova', flag: '\uD83C\uDDF2\uD83C\uDDE9', shortDesc: 'Chi\u0219in\u0103u, B\u0103l\u021bi, Tiraspol' },
            { slug: 'monaco', name: 'Monaco', flag: '\uD83C\uDDF2\uD83C\uDDE8', shortDesc: 'Monte Carlo, La Condamine' },
            { slug: 'montenegro', name: 'Montenegro', flag: '\uD83C\uDDF2\uD83C\uDDEA', shortDesc: 'Podgorica, Budva, Kotor' },
            { slug: 'netherlands', name: 'Netherlands', flag: '\uD83C\uDDF3\uD83C\uDDF1', shortDesc: 'Amsterdam, Rotterdam, The Hague, Utrecht' },
            { slug: 'north-macedonia', name: 'North Macedonia', flag: '\uD83C\uDDF2\uD83C\uDDF0', shortDesc: 'Skopje, Bitola, Ohrid' },
            { slug: 'norway', name: 'Norway', flag: '\uD83C\uDDF3\uD83C\uDDF4', shortDesc: 'Oslo, Bergen, Trondheim, Stavanger' },
            { slug: 'poland', name: 'Poland', flag: '\uD83C\uDDF5\uD83C\uDDF1', shortDesc: 'Warsaw, Krak\u00f3w, Wroc\u0142aw, Gda\u0144sk, Pozna\u0144' },
            { slug: 'portugal', name: 'Portugal', flag: '\uD83C\uDDF5\uD83C\uDDF9', shortDesc: 'Lisbon, Porto, Faro, Braga' },
            { slug: 'romania', name: 'Romania', flag: '\uD83C\uDDF7\uD83C\uDDF4', shortDesc: 'Bucharest, Cluj-Napoca, Timi\u0219oara, Ia\u0219i' },
            { slug: 'san-marino', name: 'San Marino', flag: '\uD83C\uDDF8\uD83C\uDDF2', shortDesc: 'San Marino City, Serravalle' },
            { slug: 'serbia', name: 'Serbia', flag: '\uD83C\uDDF7\uD83C\uDDF8', shortDesc: 'Belgrade, Novi Sad, Ni\u0161' },
            { slug: 'slovenia', name: 'Slovenia', flag: '\uD83C\uDDF8\uD83C\uDDEE', shortDesc: 'Ljubljana, Maribor, Celje' },
            { slug: 'spain', name: 'Spain', flag: '\uD83C\uDDEA\uD83C\uDDF8', shortDesc: 'Madrid, Barcelona, Valencia, Seville, Malaga' },
            { slug: 'sweden', name: 'Sweden', flag: '\uD83C\uDDF8\uD83C\uDDEA', shortDesc: 'Stockholm, Gothenburg, Malm\u00f6, Uppsala' },
            { slug: 'switzerland', name: 'Switzerland', flag: '\uD83C\uDDE8\uD83C\uDDED', shortDesc: 'Zurich, Geneva, Basel, Bern' },
            { slug: 'ukraine', name: 'Ukraine', flag: '\uD83C\uDDFA\uD83C\uDDE6', shortDesc: 'Kyiv, Odesa, Lviv, Kharkiv' },
            { slug: 'united-kingdom', name: 'United Kingdom', flag: '\uD83C\uDDEC\uD83C\uDDE7', shortDesc: 'London, Manchester, Birmingham, Edinburgh' },
            { slug: 'vatican-city', name: 'Vatican City', flag: '\uD83C\uDDFB\uD83C\uDDE6', shortDesc: 'Vatican City' },
          ]
        },
        {
          name: 'Middle East',
          destinations: [
            { slug: 'uae', name: 'United Arab Emirates', flag: '\uD83C\uDDE6\uD83C\uDDEA', shortDesc: 'Dubai, Abu Dhabi, Sharjah' },
            { slug: 'saudi-arabia', name: 'Saudi Arabia', flag: '\uD83C\uDDF8\uD83C\uDDE6', shortDesc: 'Riyadh, Jeddah, Dammam' },
            { slug: 'qatar', name: 'Qatar', flag: '\uD83C\uDDF6\uD83C\uDDE6', shortDesc: 'Doha, Al Wakrah, Al Khor' },
            { slug: 'kuwait', name: 'Kuwait', flag: '\uD83C\uDDF0\uD83C\uDDFC', shortDesc: 'Kuwait City, Hawalli, Salmiya' },
            { slug: 'bahrain', name: 'Bahrain', flag: '\uD83C\uDDE7\uD83C\uDDED', shortDesc: 'Manama, Muharraq, Riffa' },
            { slug: 'oman', name: 'Oman', flag: '\uD83C\uDDF4\uD83C\uDDF2', shortDesc: 'Muscat, Salalah, Sohar' },
          ]
        },
        {
          name: 'Asia & Pacific',
          destinations: [
            { slug: 'china', name: 'China', flag: '\uD83C\uDDE8\uD83C\uDDF3', shortDesc: 'Shanghai, Beijing, Guangzhou, Shenzhen' },
            { slug: 'japan', name: 'Japan', flag: '\uD83C\uDDEF\uD83C\uDDF5', shortDesc: 'Tokyo, Osaka, Yokohama, Nagoya' },
            { slug: 'south-korea', name: 'South Korea', flag: '\uD83C\uDDF0\uD83C\uDDF7', shortDesc: 'Seoul, Busan, Incheon, Daegu' },
            { slug: 'singapore', name: 'Singapore', flag: '\uD83C\uDDF8\uD83C\uDDEC', shortDesc: 'Singapore' },
            { slug: 'hong-kong', name: 'Hong Kong', flag: '\uD83C\uDDED\uD83C\uDDF0', shortDesc: 'Hong Kong, Kowloon' },
            { slug: 'thailand', name: 'Thailand', flag: '\uD83C\uDDF9\uD83C\uDDED', shortDesc: 'Bangkok, Phuket, Chiang Mai, Pattaya' },
            { slug: 'indonesia', name: 'Indonesia', flag: '\uD83C\uDDEE\uD83C\uDDE9', shortDesc: 'Jakarta, Surabaya, Bali, Bandung' },
            { slug: 'malaysia', name: 'Malaysia', flag: '\uD83C\uDDF2\uD83C\uDDFE', shortDesc: 'Kuala Lumpur, Penang, Johor Bahru' },
            { slug: 'vietnam', name: 'Vietnam', flag: '\uD83C\uDDFB\uD83C\uDDF3', shortDesc: 'Ho Chi Minh City, Hanoi, Da Nang' },
            { slug: 'philippines', name: 'Philippines', flag: '\uD83C\uDDF5\uD83C\uDDED', shortDesc: 'Manila, Cebu, Davao' },
            { slug: 'kazakhstan', name: 'Kazakhstan', flag: '\uD83C\uDDF0\uD83C\uDDFF', shortDesc: 'Almaty, Astana, Shymkent' },
          ]
        },
        {
          name: 'Americas',
          destinations: [
            { slug: 'united-states', name: 'United States', flag: '\uD83C\uDDFA\uD83C\uDDF8', shortDesc: 'New York, Los Angeles, Miami, Chicago, Houston' },
            { slug: 'canada', name: 'Canada', flag: '\uD83C\uDDE8\uD83C\uDDE6', shortDesc: 'Toronto, Vancouver, Montreal, Calgary' },
          ]
        },
        {
          name: 'Oceania',
          destinations: [
            { slug: 'australia', name: 'Australia', flag: '\uD83C\uDDE6\uD83C\uDDFA', shortDesc: 'Sydney, Melbourne, Brisbane, Perth' },
            { slug: 'new-zealand', name: 'New Zealand', flag: '\uD83C\uDDF3\uD83C\uDDFF', shortDesc: 'Auckland, Wellington, Christchurch' },
          ]
        },
        {
          name: 'Africa',
          destinations: [
            { slug: 'africa', name: 'African Countries', flag: '\uD83C\uDF0D', shortDesc: 'Nigeria, Kenya, South Africa, Ghana & more' },
          ]
        }
      ]
    };
  },
  mounted() {
    import('../seo.js').then(({ setPageSeo }) => setPageSeo({
      title: 'Car Export Destinations | Worldwide Delivery from Europe | Selected Cars',
      description: 'Export luxury European cars worldwide. We deliver to 60+ countries across Europe, Middle East, Asia, Americas, Africa and Oceania. Competitive prices on BMW, Mercedes, Porsche, Ferrari from our 92-dealer European network.',
      keywords: 'car export destinations, export car from europe worldwide, car shipping europe, european car export countries, luxury car shipping worldwide, buy car europe export, selected cars export, car export europe to asia, car export europe to middle east, car export europe to americas',
      breadcrumbs: [
        { name: 'Home', url: '/' },
        { name: 'Export Destinations', url: '/export' }
      ]
    }));
  }
};
</script>

<style scoped>
.dest-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: #222;
  border: 1px solid rgba(255,255,255,0.12);
  text-decoration: none;
  transition: border-color 0.3s, background 0.3s;
  height: 100%;
}
.dest-card:hover {
  background: #2a2a2a;
  border-color: rgba(255,255,255,0.3);
}
.dest-card--flag {
  font-size: 2rem;
  flex-shrink: 0;
}
.dest-card--info { flex: 1; }
.dest-card--name {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.2rem;
}
.dest-card--desc {
  font-size: 0.78rem;
  color: rgba(255,255,255,0.55);
  line-height: 1.4;
}
.dest-card--arrow {
  color: rgba(255,255,255,0.3);
  font-size: 1.2rem;
  flex-shrink: 0;
  transition: color 0.3s;
}
.dest-card:hover .dest-card--arrow { color: #fff; }
</style>
